import React, { useState } from 'react';
import styles from './ForgotPassword.module.css';
import { getAuth } from '@firebase/auth';
import { Button, TextField } from '@mui/material';
import { useForm } from 'react-hook-form';
import { severity } from '../../../common/models/severity.enum';
import { ServiceManager } from '../../../services/service-manager';
import { emailRegex } from '../../../common/firebase/regex';
import { sendPasswordResetEmail } from 'firebase/auth';
import { useNavigate } from 'react-router';
import { handleError } from '../../../common/firebase/auth-error.service';

const ForgotPassword = ({ user }) => {

    const [emailSentTo, setEmailSentTo] = useState('');
    const navigate = useNavigate();

    const { register, handleSubmit, formState: { errors } } = useForm<{ email: string, password: string }>();

    const onSubmit = (data) => {
        const auth = getAuth();
        sendPasswordResetEmail(auth, data.email)
            .then(() => {
                ServiceManager.snackbarService.openSnackbar(`Wachtwoord reset email is verstuurd naar "${data.email}"`, severity.success, 6000);
                setEmailSentTo(data.email);
            })
            .catch((error) => {
                handleError(error);
            });
    }

    return (
        <div className={styles.ForgotPassword} data-testid="ForgotPassword">
            {emailSentTo ?
                <p>
                    Wachtwoord reset email is verstuurd naar "{emailSentTo}". Als u binnen een paar minuten de email niet kan vinden controleer dan uw spambox of probeer nog een keer.
                </p> :
                <form data-testid="forgot-password-form" onSubmit={handleSubmit(onSubmit)}>
                    <div>
                        <TextField id="forgot-password-email"
                            fullWidth
                            className="form-input"
                            label="E-mailadres"
                            value={user?.email}
                            {...register('email', {
                                required: { value: true, message: 'U moet uw e-mailadres invullen.' }, pattern: {
                                    value: emailRegex,
                                    message: 'Het e-mailadres voldoet niet aan de regels.'
                                }
                            })}
                            variant="standard"
                        />
                        {errors.email && <p className="input-error">{errors.email.message}</p>}
                    </div>
                    <div className={styles.actions}>
                        <div>
                            <Button color="primary" data-testid="forgot-password-submit" variant="contained" type="submit">Email Link</Button>
                        </div>
                    </div>
                </form>
            }

        </div>
    )
};

export default ForgotPassword;
